module.exports = __webpack_public_path__ + "static/comingsoon_w600xh400-2bc5288c5bcb5ceb749848045ae544d6.jpg";